import React, { FC } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const dadosTexto = {
  Titulo: 'O QUE FALAM SOBRE A GENTE',
  Texto: 'Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.'
};

const testemunhoData = [
  {
    Imagem: '/images/t1.png',
    Nome: 'Yasmin Silva',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t2.png',
    Nome: 'Thiago Oliveira',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t3.png',
    Nome: 'Rousilene Amparo',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t4.png',
    Nome: 'Maira Roberta',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
];

const Testemunho: FC = () => {
  return (
    <section id="testemunhos" className="text-center px-6 lg:px-14 bg-theme-primary py-12">
      <h2 className="text-textotitulo font-bold text-theme-light-primary mb-4">{definicoescliente?.Testemunho?.Titulo || dadosTexto.Titulo}</h2>
      <p className="text-theme-light-primary text-textopadrao mb-8 max-w-xl mx-auto">
        {definicoescliente?.Testemunho?.Descricao || dadosTexto.Texto}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {(definicoescliente.Testemunho.Depoimento.length ? definicoescliente.Testemunho.Depoimento : testemunhoData)
          .map((testemunho, index) => (
          <div key={index} className="flex flex-col items-left bg-theme-light-secondary p-6 rounded-lg shadow-md">
            <img src={testemunho.Imagem || testemunhoData[index]?.Imagem} alt={testemunho.Nome || testemunhoData[index]?.Nome} className="w-24 h-24 mb-4 object-cover"/>
            <h3 className="text-textotitulo text-left text-theme-secondary font-semibold">{testemunho.Nome || testemunhoData[index]?.Nome}</h3>
            <p className="text-theme-secondary  text-left text-textopadrao mb-4">{testemunho.Descricao || testemunhoData[index]?.Descricao}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testemunho;
